import * as z from 'zod';
import {
  chatMacroSchema,
  conversationIdSchema,
  macroLangSchema,
} from '@/entities/conversation';

/**
 * Zod schemas of the conversation write-actions: the modal payloads (validated
 * by the modal host before a modal mounts) and the form values.
 */

/** Statuses a chat can be closed with (3 = resolved, 4 = not resolved). */
export const closeStatusSchema = z.union([z.literal(3), z.literal(4)]);
export type CloseStatus = z.infer<typeof closeStatusSchema>;

/** `close-chat` modal payload. */
export const closeChatPayloadSchema = z.object({ chatId: conversationIdSchema });
export type CloseChatPayload = z.infer<typeof closeChatPayloadSchema>;

/** Close form: both fields are required (cpanel "Введите все поля"). */
export const closeChatFormSchema = z.object({
  status: closeStatusSchema,
  reason: z.string().trim().min(1),
});
export type CloseChatFormValues = z.infer<typeof closeChatFormSchema>;

/** `switch-operator` modal payload. */
export const switchOperatorPayloadSchema = z.object({ chatId: conversationIdSchema });
export type SwitchOperatorPayload = z.infer<typeof switchOperatorPayloadSchema>;

/** `chat-macro` modal payload — create when `macro` is absent, else edit it. */
export const chatMacroPayloadSchema = z.object({
  lang: macroLangSchema,
  macro: chatMacroSchema.optional(),
});
export type ChatMacroPayload = z.infer<typeof chatMacroPayloadSchema>;

/** Macro form limits (cpanel inputProps). */
export const MACRO_TITLE_MAX = 100;
export const MACRO_MESSAGE_MAX = 4000;

export const chatMacroFormSchema = z.object({
  lang: macroLangSchema,
  title: z.string().trim().min(1).max(MACRO_TITLE_MAX),
  message: z.string().trim().min(1).max(MACRO_MESSAGE_MAX),
});
export type ChatMacroFormValues = z.infer<typeof chatMacroFormSchema>;
